import * as olProj from 'ol/proj';

const appLocales = ['es-ES', 'en-UK', 'en-US']; // TODO: Poner en composable o algo
const formatNumber = new Intl.NumberFormat(appLocales, {style: 'decimal'});
// Default Dots per centimeter
export const DEFAULT_SCREEN_DPI = 75;
export const DEFAULT_SCREEN_DPC = (DEFAULT_SCREEN_DPI * 100) / 254;
export const DEFAULT_PRINT_DPI = 300;
export const DEFAULT_PRINT_DPC = (DEFAULT_PRINT_DPI * 100) / 254;
const INCHES_PER_METER = 10000 / 254;

// 1:scale (meters)
export const OPTIONS_SCALE_METERS = [
  75 * 1000,
  150 * 1000,
  300 * 1000,
  500 * 1000,
  1 * 1000 * 1000,
  2.5 * 1000 * 1000,
  5 * 1000 * 1000,
  10 * 1000 * 1000,
  12.5 * 1000 * 1000,
];
export const MENU_ITEM_SCALES =
  OPTIONS_SCALE_METERS.map((scale) => {
    return {
      id: 'scale:' + scale,
      title: '1:' + formatNumber.format(scale),
      // title: '1:' + scale,
      data: {scale},
    };
  });

export function dpc2dpi(dpc) {
  return (dpc * 2.54);
}

export function dpi2dpc(dpi) {
  return ((dpi * 100) / 254);
}

export function calculateZoomLevelDPI(
  map, scale,
  dpi = DEFAULT_SCREEN_DPI,
) {
  const mpu = map.getView().getProjection().getMetersPerUnit();
  const latitude = olProj.toLonLat(map.getView().getCenter())[1];
  const factor = 1 / Math.cos(latitude * Math.PI / 180);
  const desiredResolution = factor * scale / (mpu * INCHES_PER_METER * dpi);
  const zoomLevel = map.getView().getZoomForResolution(desiredResolution);
  return zoomLevel;
}

export function calculateZoomLevel(
  map, scale,
  dpc = dpi2dpc(DEFAULT_SCREEN_DPI),
) {
  const mpu = map.getView().getProjection().getMetersPerUnit();
  const latitude = olProj.toLonLat(map.getView().getCenter())[1];
  const factor = 1 / Math.cos(latitude * Math.PI / 180);
  const desiredResolution = factor * scale / (mpu * 100 * dpc);
  const zoomLevel = map.getView().getZoomForResolution(desiredResolution);
  return zoomLevel;
}

export const inches2mm = ((i) => i * 25.4);
export const mm2inches = ((mm) => (mm * 10) / 254);
export const inches2cm = ((i) => inches2mm(i) / 10);
export const cm2inches = ((cm) => mm2inches(cm * 10));

// https://www.sven.de/dpi/
export function dpcFromScreenData(
  mmDiagonal,
  resolutionX = 1920,
  resolutionY = 1080,
) {
  const ratio = resolutionY / resolutionX;
  const xd = Math.sqrt(Math.pow(mmDiagonal, 2) / (1 + Math.pow(ratio, 2)));
  const yd = xd * ratio;
  const mmDotPitch = (x / xd);
  const result = {
    mmDiagonal,
    mmSizeX: xd,
    mmSizeY: yd,
    mmArea: xd * yd,
    xppc: (resolutionX / xd) / 10,
    yppc: (resolutionY / yd) / 10,
    mmDotPitch,
    sqppc: xppc * yppc,
  };
  return result;
}

export function dpcFromScreenMeasure(
  mmX,
  mmY,
  pixelsX = 200,
  pixelsY = 200,
) {
  const cmX = mmX / 10;
  const xppmm = pixelsX / mmX;
  const xppc = pixelsX / cmX;
  const cmY = mmY / 10;
  const yppmm = pixelsY / mmY;
  const yppc = pixelsY / cmY;
  const dmm = Math.sqrt(Math.pow(mmX, 2) + Math.pow(mmY, 2));
  const dcm = dmm / 10;
  const dpixels = Math.sqrt(Math.pow(pixelsX, 2) + Math.pow(pixelsY, 2));
  const dppmm = dpixels / dmm;
  const dppc = dpixels / dcm;
  // const sqppmm = xppmm * yppmm;
  const sqppmm = (pixelsX * pixelsY) / (mmX * mmY);
  // const sqppc = xppc * yppc;
  const sqppc = (pixelsX * pixelsY) / (cmX * cmY);
  return {
    xppmm,
    yppmm,
    xppc,
    yppc,
    dppmm,
    dppc,
    sqppmm,
    sqppc,
  };
}

// Pre: resolution in meters per pixel
// dpc dots per centimeter
export function getScaleFromResolution(resolution, dpc) {
  const scale = resolution * dpc * 100;
  return scale;
}
